import { DeleteOutlined } from "@ant-design/icons";
import { Button, Input } from "antd";
import { Text } from "common/base/Text";
import React from "react";
import styled from "styled-components";
import { IQuestionOption } from "utils/types";


const OptionContainer = styled.div`
  margin-top: 4px;
`;

const OptionLabel = styled(Text)`
  font-size: 14px;
  color: #666;
  display: block;
  margin-top: 16px;
  margin-bottom: 8px;
`;

const OptionItem = styled.div`
  margin-bottom: 12px;
  position: relative;
`;

const DeleteButton = styled(Button)`
  position: absolute;
  right: 0;
  color: #ff4d4f;
  border: none;
  background: transparent;

  &:hover {
    color: #ff7875;
    background: transparent;
  }
`;


export interface QuizOptionsProps {
    questionOptions: IQuestionOption[];
    setQuestionOptions: (questionOptions: IQuestionOption[], questionOptionId?: string) => void;

    isEdit?: boolean;
    onUpdateQuestionOption?: (optionId: string, questionOption: Partial<IQuestionOption>) => void;
    onDeleteOption?: (optionId: string) => void;
}
export const QuizOptions:React.FC<QuizOptionsProps> = ({
    questionOptions, setQuestionOptions, isEdit, onUpdateQuestionOption,
    onDeleteOption,
}) => {

    return (
        <>
            {questionOptions?.map((questionOption, optIndex) => { 
                return (
                <OptionContainer key={questionOption.id}>
                    <OptionLabel>Option {optIndex + 1}</OptionLabel>
                    <OptionItem>
                    <Input
                        size="large"
                        value={questionOption?.text}
                        onChange={(e) => {
                            const text = e.target.value;
                            questionOptions[optIndex].text = text
                            setQuestionOptions([...questionOptions])
                            if(isEdit && questionOption && onUpdateQuestionOption){
                                onUpdateQuestionOption(questionOption?.id, { text })
                            }
                        }}
                        placeholder={`Enter question option ${optIndex + 1}`}
                    />
                    {questionOptions.length > 1 && (
                        <DeleteButton
                            type="text"
                            icon={<DeleteOutlined />}
                            onClick={() => {
                                if(isEdit && onDeleteOption){
                                    onDeleteOption(questionOption.id)
                                }else {
                                    questionOptions.splice(optIndex, 1)
                                    setQuestionOptions([...questionOptions], questionOption.id)
                                }
                            }}
                        />
                    )}
                    </OptionItem>
                </OptionContainer>
                )
            })}
        </>
    )
}